import React from 'react';
import { 
  FaRegImages, 
  FaReact, 
  FaProjectDiagram, 
  FaCogs, 
  FaTools, 
  FaBuilding, 
  FaIndustry, 
  FaLayerGroup, 
  FaDraftingCompass 
} from 'react-icons/fa';
import { FaEarthAmericas } from 'react-icons/fa6';
import "../CSS/OtherSkills.css";

const OtherSkills = () => {
  return (
    <div className='OurServicesWrap'>
      <div className='SkillLine'></div>
      <div className='OurServices'>
        <div className='OurServicesHeading'>
          <h1 style={{color:"#f4f4f4"}}>My Skills & Expertise</h1>
        </div>

        <div className='OurServicesBody'>


   <div className='OurServicesHeading'>
          <h1 style={{color:"#f4f4f4", fontSize:"2rem"}}>Engineering:</h1>
        </div>


          {/* Autodesk Skills individually coded */}
          <div className='OurService'>
            <FaCogs className='OurServiceBodyIcon'/>
            <h2>Autodesk Revit</h2>
          </div>

          <div className='OurService'>
            <FaTools className='OurServiceBodyIcon'/>
            <h2>Autodesk Civil 3D</h2>
          </div>

          <div className='OurService'>
            <FaBuilding className='OurServiceBodyIcon'/>
            <h2>Autodesk Infraworks</h2>
          </div>

          <div className='OurService'>
            <FaIndustry className='OurServiceBodyIcon'/>
            <h2>Autodesk Storm & Sanitary Analysis</h2>
          </div>

          <div className='OurService'>
            <FaLayerGroup className='OurServiceBodyIcon'/>
            <h2>Autodesk Robot Structural Analysis</h2>
          </div>

          <div className='OurService'>
            <FaDraftingCompass className='OurServiceBodyIcon'/>
            <h2>Autodesk Advanced Steel</h2>
          </div>

          <div className='OurService'>
            <FaProjectDiagram className='OurServiceBodyIcon'/>
            <h2>Autodesk Plant 3D</h2>
          </div>
       </div>

<br/>
<br/>
<br/>

<div className='OurServicesBody'>



          {/* Existing skills */}


 <div className='OurService'>
            <FaRegImages className='OurServiceBodyIcon'/>
            <h2>Scan-To-BIM:</h2>
            <span>Cyclone Register 360, Agisoft Metashape Professional, Autodesk Recap PRO, Clear Edge Wise, Faro As-Built for Revit.</span>
          </div>

    <div className='OurService'>
            <FaProjectDiagram className='OurServiceBodyIcon'/>
            <h2>BIM Project Management:</h2>
            <span>Microsoft Project, Autodesk Navisworks.</span>
          </div> 

          <div className='OurService'>
            <FaEarthAmericas className='OurServiceBodyIcon'/>
            <h2>Geological Information System:</h2>
            <span>ArcGIS Suite (Arc Map, Arc Scene), QGIS, Google Earth Pro.</span>
          </div>

         
          <div className='OurService'>
            <FaReact className='OurServiceBodyIcon'/>
            <h2>Virtual Reality:</h2>
            <span>Unreal Engine, Twin Motion.</span>
          </div>

      
          
        


        </div>

      </div>
    </div>
  );
};

export default OtherSkills;
